export const SCENE_ACTION = 'ActionInvokeScene';

export interface Room {
  id: string;
  name: string;
  typeId: string;
}

export interface Dock {
  number?: string;
  typeId?: string;
  snapInCode?: string | null;
  positionId?: string;
  snapInId?: string | null;
  zigbeeId?: string | null;
  devices?: Device[];
}

export interface DocksMap {
  [key: string]: Dock[];
}

export interface Device {
  id: string;
  symbol?: string;
  name?: string;
  actions?: Object;
  events?: Object;
  alwaysOn?: boolean;
}

export interface Connection {
  id: string;
  sourceDeviceNumber: string;
  sourceDockNumber: string;
  targetAction: string;
  targetActionParameters: any;
  targetDeviceNumber: number;
  targetDockNumber: string;
  triggerEvent: string;
  triggerEventParameters: any;
}

export interface ConnectionConfig {
  id?: string;
  sourceDeviceNumber?: number;
  sourceDockNumber?: string;
  triggerEvent?: string;
  triggerEventParameters?: any;
  targetAction?: string;
  targetActionParameters?: any;
  targetDockNumber?: string;
  targetDeviceNumber?: number;
}

export interface IInputDevice {
  connectionInputConfig: {
    sourceDeviceNumber?: number;
    sourceDockNumber?: string;
    triggerEvent?: string;
    triggerEventParameters?: any;
    targetAction?: string;
    targetActionParameters?: any;
    targetDockNumber?: string;
    targetDeviceNumber?: number;
  };
  id: string;
  startsFrom: string;
  symbol: string;
}

export interface SceneAction {
  dockNumber: string;
  deviceNumber: number;
  action: string;
  actionParameters: string;
}

export interface Scene {
  actions: SceneAction[];
  id: string;
  version: number;
  locationId: string;
  name: string;
  enabled: boolean;
  modificationTimestamp: string;
  modificationVersion: string;
  roomIds: string[];
}
export interface SnapIn {
  id: string;
  serialNumber: string;
  snapInCode: string;
  macAddress: string;
  zigbeeId: string;
  snapInStatus: string;
  locationId: string;
}

export interface IColor {
  Brightness: number;
  Color: {
    hue: number;
    saturation: number;
  };
}
